import { render } from "./TopBar.vue?vue&type=template&id=40ed6948&scoped=true&ts=true"
import script from "./TopBar.vue?vue&type=script&lang=ts"
export * from "./TopBar.vue?vue&type=script&lang=ts"

import "./TopBar.vue?vue&type=style&index=0&id=40ed6948&scoped=true&lang=less"

import exportComponent from "/Users/fanglegefang/Desktop/Feiyi_sign_2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40ed6948"]])

export default __exports__